const round = (num) => Math.floor(num * 100) / 100;

const dollars = (value) => {
  const formatted = Math.round(value).toLocaleString('en-US');
  return `$${formatted}`;
};

const decimalPercent = (value) => `${round(value * 100).toLocaleString('en-US')}%`;
const integerFormat = (value) => `${round(value).toLocaleString('en-US')}`;
const decimalFormat = (value) => `${(round(value * 100) / 100).toLocaleString('en-US')}`;

const FORMATS = {
  dollars,
  DOLLARS: dollars,
  decimal_percent: decimalPercent,
  PERCENT: decimalPercent,
  small_decimal_percent: (value) => `${(Math.floor(value * 1000000) / 10000).toLocaleString('en-US')}%`,
  text_map: (value, map) => `${map[value] || value}`,
  number: integerFormat,
  NUMBER: integerFormat,
  DECIMAL: decimalFormat,
  INTEGER: integerFormat,
};

export const formatLabel = (label, unit, map) => {
  if (!unit) return label;

  return (FORMATS[unit] ? FORMATS[unit](label, map) : `${label} ${unit}`);
};
